import React from "react";
import styles from "./datePicker.module.css";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../src/index.css"; // Add this new global CSS file
const DatePicker = ({ id, label, key, required = false, ...datePickerProps }) => {
    return (
        <div className={styles.formGroup} style={datePickerProps.formGroupStyleOverride} key={key}>
            <label htmlFor={id} style={datePickerProps.labelStyleOverride}>
                {label}{required && <span className="required">*</span>}
            </label>
            <div className={styles.datePickerContainer}>
                <ReactDatePicker
                    {...datePickerProps}
                    required
                    className={styles.reactDatepickerWrapper}
                    dateFormat="MMMM d, yyyy"
                    calendarClassName="custom-calendar"
                    renderCustomHeader={({
                        date,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled
                    }) => (
                        <div className="header-container">
                            <button
                                className="nav-button"
                                onClick={decreaseMonth}
                                disabled={prevMonthButtonDisabled}
                            >
                                ◀
                            </button>
                            <div className="month-year-label">
                                <span className="month-label">{date.toLocaleString('default', { month: 'long' })}</span>
                                {' '}
                                <span className="year-label">{date.getFullYear()}</span>
                            </div>
                            <button
                                className="nav-button"
                                onClick={increaseMonth}
                                disabled={nextMonthButtonDisabled}
                            >
                                ▶
                            </button>
                        </div>
                    )}
                    todayButton="Today"
                    // isClearable={true}
                />
            </div>
        </div>
    );
};

export default React.memo(DatePicker);